var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170,
    height: 190,
    viewBox: "0 0 170 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6dcef8;}.b{fill:#c3e678;}.c{fill:#0da750;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.483)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M176.765,128.07l-65.282,54.546L50.2,123.63a84.987,84.987,0,1,0,126.563,4.44Z",
    transform: "translate(0 -77.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.475,79.12l61.306,58.853V52.966A84.736,84.736,0,0,0,90.475,79.12Z",
    transform: "translate(-40.291 -33.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M345.828,30.6l0-.017A84.818,84.818,0,0,0,280.541,0V85.007Z",
    transform: "translate(-159.976)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.ba5db0f33e224ee1d5939377db50e004.svg";
export { ForwardRef as ReactComponent };